import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

const mealsApi = {
  updateRecipeImage: async (mealId: string, pageNumber: number, imageUrl: string, expectedImageUrl: string | null) => {
    const response = await axios.put(`${API_URL}/api/admin/meals/${mealId}/recipe-image`,
      { pageNumber, imageUrl, expectedImageUrl },
      { headers: { Authorization: `Bearer ${localStorage.getItem("adminToken")}` } });
    return response.data;
  },
  getMeals: async (filters: any = {}) => {
    const { search, category, page, limit, sortBy = "serialNumber", sortOrder = "asc" } = filters;
    let url = `${API_URL}/api/admin/meals?sortBy=${sortBy}&sortOrder=${sortOrder}`;

    if (page) {
      url += `&page=${page}`;
    }
    if (limit) {
      url += `&limit=${limit}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    if (category) {
      url += `&category=${encodeURIComponent(category)}`;
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  getMealById: async (mealId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/meals/${mealId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });

    return response.data;
  },

  createMeal: async (mealData: any) => {
    const response = await axios.post(
      `${API_URL}/api/admin/meals`,
      mealData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  updateMeal: async (mealId: string, mealData: any) => {
    const response = await axios.put(
      `${API_URL}/api/admin/meals/${mealId}`,
      mealData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  patchMeal: async (mealId: string, mealData: any) => {
    const response = await axios.patch(
      `${API_URL}/api/admin/meals/${mealId}`,
      mealData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },

  getMealFeedbacks: async (mealId: string) => {
    const response = await axios.get(`${API_URL}/api/admin/meals/${mealId}/feedbacks`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
      },
    });
    return response.data;
  },

  deleteMeal: async (mealId: string) => {
    const response = await axios.delete(
      `${API_URL}/api/admin/meals/${mealId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("adminToken")}`,
        },
      }
    );

    return response.data;
  },
};

export default mealsApi;
